module.exports = __webpack_public_path__ + "img/phoxDash2.f285b77d.png";